
export enum CustomerImageType {
    TOP_OF_STACK = 0,
    RECENT = 1,
    CREDENTIAL = 2,
    DRIVER_DEFAULT = 3,
    UNASSOCIATED = 4,
    OUT_OF_JURISDICTION = 5,
    ISSUANCE_TRANSACTION = 6
}
